<div class="surface-card p-6">
  <div class="mb-6 flex items-center justify-between">
    <div>
      <h2 class="mb-1 text-xl font-semibold text-text-primary">{{ 'seekerDashboard.previews.title' | translate }}</h2>
      <p class="text-sm text-text-secondary">{{ 'seekerDashboard.previews.subtitle' | translate }} {{ viewings.length }} {{
        'seekerDashboard.previews.subtitleSuffix' | translate }}</p>
    </div>
    <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-surface-elevated text-primary border border-border">
      <i class="fa-solid fa-calendar-days text-xl"></i>
    </div>
  </div>

  @if (isLoading) {
  <div class="rounded-xl border border-border-subtle bg-surface-hover p-10 text-center">
    <i class="fas fa-spinner fa-spin text-3xl text-primary"></i>
    <p class="mt-3 text-text-secondary">{{ 'seekerDashboard.previews.loading' | translate }}</p>
  </div>
  } @else if (errorMessage) {
  <div class="alert alert-danger max-w-md mx-auto items-center justify-between text-center rounded-2xl shadow-elevated">
    <span>{{ errorMessage }}</span>
    <button (click)="loadViewings()" class="btn btn-danger px-4 py-2 mt-4">{{ 'seekerDashboard.previews.errorRetry' | translate }}</button>
  </div>
  } @else if (viewings.length === 0) {
  <div class="rounded-xl border border-border-subtle bg-surface-hover p-10 text-center">
    <i class="fa-regular fa-calendar-xmark text-5xl text-text-muted mb-4 block"></i>
    <h3 class="text-lg font-bold text-text-primary mb-1">{{ 'seekerDashboard.previews.noVisitsTitle' | translate }}</h3>
    <p class="text-sm text-text-secondary">{{ 'seekerDashboard.previews.noVisitsSubtitle' | translate }}</p>
  </div>
  } @else {
  <div class="space-y-4 grid grid-cols-1 md:grid-cols-2 gap-4">
    @for (viewing of viewings; track trackByViewingId($index, viewing)) {
    <div class="surface-card p-5 hover:border-primary/50 transition-colors border-border-subtle shadow-none">
      <div class="mb-4 flex items-start justify-between gap-4">
        <div class="min-w-0">
          <h3 class="mb-1 truncate text-text-primary font-semibold">{{ viewing.title || ('seekerDashboard.previews.untitledUnit' |
            translate) }}</h3>
          <div class="flex items-center gap-1 text-sm text-text-muted">
            <i class="fa-solid fa-location-dot"></i>
            <span class="truncate">{{ viewing.location || ('seekerDashboard.previews.unknownLocation' | translate)
              }}</span>
          </div>
        </div>
        <span class="badge badge-primary text-xs" [ngClass]="getStatusClasses(viewing.status)">
          {{ getStatusLabel(viewing.status) }}
        </span>
      </div>

      <div class="mb-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 text-sm text-text-secondary">
        <div class="flex items-center gap-2">
          <i class="fa-solid fa-calendar-days text-text-muted"></i>
          <span>{{ viewing.scheduledDate | date: 'yyyy-MM-dd' }}</span>
        </div>
        <div class="flex items-center gap-2">
          <i class="fa-solid fa-clock text-text-muted"></i>
          <span>{{ getDisplayTime(viewing) }}</span>
        </div>
        <div class="flex items-center gap-2">
          <i class="fa-solid fa-user text-text-muted"></i>
          <span>{{ getContactName(viewing) }}</span>
        </div>
        <div class="flex items-center gap-2">
          <i class="fa-solid fa-phone text-text-muted"></i>
          <span>{{ getContactPhone(viewing) }}</span>
        </div>
      </div>

      @if (viewing.notes) {
      <div class="mb-4 rounded-lg border border-border-subtle bg-surface-elevated p-3 text-sm text-text-secondary">
        {{ viewing.notes }}
      </div>
      }

      @if (viewing.image) {
      <img [src]="viewing.image" [alt]="viewing.title || ('seekerDashboard.previews.untitledUnit' | translate)"
        class="h-40 w-full rounded-lg object-cover" />
      }
    </div>
    }
  </div>
  }
</div>